import { createSelector } from 'reselect';
import {
  selectQuery,
  selectType,
} from '../../../ReduxStorage/location/selectors.common';
import { ROUTE_INSTITUTION_ADMIN } from '../../../ReduxStorage/routeActions';

export const selectCurrentInstitutionAdminAction = createSelector(
  [selectType, selectQuery],
  (actionType, query) => {
    if (actionType !== ROUTE_INSTITUTION_ADMIN) {
      return null;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return query.get('action');
  }
);
